export default __webpack_public_path__ + "static/media/Email.ad2eb2f9.png";